import Vue from 'vue'
const debug = false

class EventBus {
  constructor () {
    this.vue = new Vue()
  }

  on (event, callback) {
    if (debug) console.log('[BUS]', 'ON ' + event)
    return this.vue.$on(event, callback)
  }

  once (event, callback) {
    if (debug) console.log('[BUS]', 'ONCE ' + event)
    return this.vue.$once(event, callback)
  }

  off (event, callback) {
    if (debug) console.log('[BUS]', 'OFF ' + event)
    return this.vue.$off(event, callback)
  }

  emit (eventName, args) {
    if (debug) console.log('[BUS]', 'EMIT ' + eventName, args)
    return this.vue.$emit(eventName, args)
  }
}

export default () => {
  return new EventBus()
}